import { Link } from "react-router-dom";
import {
    Home,
    Book,
    Phone,
    Tv,
    Info,
    Moon,
    MoreVertical,
    Share2,
    Facebook,
    MessageCircle,
} from "lucide-react";
import ThemeIcons from "./ThemeIcons";

const desktopLinks = [
    { path: "/", label: "Home", icon: <Home size={20} /> },
    { path: "/live-tv", label: "Live", icon: <Tv size={20} /> },
    { path: "/books", label: "Books", icon: <Book size={20} /> },
    { path: "/contact", label: "Contact", icon: <Phone size={20} /> },
    { path: "/about", label: "About", icon: <Info size={18} /> },
];

const DesktopTaskbar = ({
    location,
    showLogoText,
    isThemeDropdownOpen,
    setIsThemeDropdownOpen,
    menuOpen,
    setMenuOpen,
    themeBtnRef,
    themeDropdownRef,
    moreBtnRef,
    moreDropdownRef,
}) => {
    return (
        <nav className="fixed top-0 w-full z-50 bg-card shadow">
            <div className="flex items-center justify-between p-1 text-text">

                <Link to="/" className="flex items-center gap-1">
                    <img src="images/taskbar/taskbar.png" alt="Logo" className="h-10 w-10 rounded-full" />
                    {showLogoText && (
                        <span className="text-xl font-bold text-secondary">
                            Prophet Kevin Online
                        </span>
                    )}
                </Link>

                <div className="flex items-center relative">
                    {desktopLinks.map(({ path, label, icon }) => (
                        <Link
                            key={path}
                            to={path}
                            className={`flex items-center px-2 py-1 text-[12px] ${location.pathname === path
                                    ? "text-primary"
                                    : "hover:text-hover"
                                }`}
                        >
                            {icon} {label}
                        </Link>
                    ))}

                    <button
                        ref={themeBtnRef}
                        onClick={() => {
                            setMenuOpen(false);
                            setIsThemeDropdownOpen((p) => !p);
                        }}
                        className="flex items-center px-2 py-1"
                    >
                        <Moon size={20} />
                        <span className="text-[12px]">Themes</span>
                    </button>

                    {isThemeDropdownOpen && (
                        <div
                            ref={themeDropdownRef}
                            className="absolute right-0 top-[63px] bg-purple-500 text-white rounded shadow-lg z-50 text-center pt-2"
                        >
                            <ThemeIcons isDropdown />
                            select your theme
                        </div>
                    )}

                    <div className="relative ml-1">
                        <button
                            ref={moreBtnRef}
                            onClick={() => {
                                setIsThemeDropdownOpen(false);
                                setMenuOpen((p) => !p);
                            }}
                            className="flex items-center"
                        >
                            <MoreVertical size={20} />
                            <span className="text-[12px]">More</span>
                        </button>

                        {menuOpen && (
                            <div
                                ref={moreDropdownRef}
                                className="absolute right-[-100px] mt-[17px] w-[250px] bg-card border rounded shadow-lg z-50"
                            >
                                <h3 className="text-center font-bold text-primary">
                                    Share to family and friends
                                </h3>

                                <button className="flex gap-3 px-4 py-3 w-full">
                                    <Share2 size={18} /> Share
                                </button>

                                <button
                                    type="button"
                                    className="flex items-center gap-3 px-4 py-3 w-full hover:border hover:rounded hover:border-border text-left"
                                >
                                    <Facebook size={18} /> Facebook
                                </button>


                                <button
                                    type="button"
                                    className="flex items-center gap-3 px-4 py-3 w-full hover:border hover:rounded hover:border-border text-left"
                                >
                                    <MessageCircle size={18} /> WhatsApp
                                </button>


                                <button
                                    type="button"
                                    className="flex items-center gap-3 px-4 py-3 w-full hover:border hover:rounded hover:border-border text-left"
                                >
                                    🎵 TikTok
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <Link to="/give" className="bg-yellow-500 rounded px-20 py-2">
                    Give
                </Link>
            </div>
        </nav>
    );
};

export default DesktopTaskbar;
